<template>
  <div class="sn-f-b-s report">
    <sn-navigator id="BGCX"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s report-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_TJBG) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 report-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>就诊人：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <template v-else-if="patientArray.length === 0">
              <div @click="navigateUrl('addition-patient');">
                暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">-</div>
          <div class="sn-f-s-c region">
            <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(handleReport)">
          <div class="sn-table">
            <table>
              <thead>
              <tr>
                <th>序号</th>
                <th>体检人姓名</th>
                <th v-if="exist('examSecond')">体检次数</th>
                <th>体检项目名</th>
                <th>体检日期</th>
                <th>体检单号</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="report.reqNo" v-for="(report, index) in handleReport">
                <td>{{ index + 1 }}</td>
                <td>{{report.examPatName}}</td>
                <td v-if="exist('examSecond')">{{report.examSecond}}</td>
                <td>{{report.examName}}</td>
                <td>{{report.examDate}}</td>
                <td>{{report.reqNo}}</td>
                <td class="sn-pointer sn-fc-main" @click="navigateUrl('/physical/report/detail', report);">查看详情</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
          :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(physicalInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import * as Constants from '@/common/utils/constants';
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient')
  },
  data() {
    return {
      perpetual: Constants,
      hosId: self.$sn.utils.getHospitalId(), // 医院ID
      patientArray: [], // 就诊人列表
      selectedPatient: {}, // 当前就诊人
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('physicalReportRange')[0], self.$sn.getConfig('physicalReportRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      physicalInfo: [], // 报告列表
      physicalArray: [],
      pageCount: 1, // 当前页码
      isResult: true, // 是否查询到结果
      exhibitionCreatePatient: false, // 是否显示创建就诊人
      exhibitionBindCard: false // 是否显示绑定就诊卡
    };
  },
  computed: {
    // 处理报告信息
    handleReport() {
      let handle = [];
      if (this.physicalInfo.length > 0) handle = this.$sn.format.group(this.physicalInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },
    exist() {
      return (key) => {
        let verify = false;
        if (this.physicalInfo.length > 0) {
          if (!this.$sn.validate.empty(this.physicalInfo.find(result => !this.$sn.validate.empty(result[key])))) {
            verify = true;
          }
        }
        return verify;
      };
    }
  },
  watch: {
    // 切换就诊人
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.physicalInfo = [];
      this.physicalArray = [];
      this.pageCount = 1;
      if (patient.patientId) this.searchBtn();
    },
    $route(val, old) {
      if ((old.path === '/physical/report' && val.path !== '/physical/report/detail') || (old.path === '/physical/report/detail' && val.path !== '/physical/report')) {
        this.initialPhysicalReport();
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.physicalInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.queryPhysicalReportTable();
        }
      },
      immediate: true
    }
  },
  created() {
    // 初始化
    this.initialPhysicalReport();
  },
  methods: {
    initialPhysicalReport() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TJBG);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TJBG);
      this.handlePatientInfo();
    },
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList') || [];
      if (this.patientArray && this.patientArray.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询
    async searchBtn() {
      this.physicalInfo = [];
      if (this.$sn.validate.empty(this.selectedPatient)) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT001,
          success: (modal) => {
            if (modal.confirm) this.navigateUrl('addition-patient');
          }
        });
        return false;
      }
      if (this.$sn.validate.empty(this.startDate)) {
        this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
        return false;
      }
      if (this.$sn.validate.empty(this.endDate)) {
        this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
        return false;
      }
      const start = new Date(this.startDate).getTime();
      const end = new Date(this.endDate).getTime();
      if (end < start) {
        this.getShowToast('结束日期不能早于开始日期');
        return false;
      }
      this.queryPhysicalReportTable();
    },
    // 体检报告
    queryPhysicalReportTable() {
      const params = {
        url: this.$sn.format.caption(Swagger.getOrdinaryPhysicalReportTable, [this.$sn.utils.getHospitalId()]),
        query: {
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          patId: this.selectedPatient.patientId,
          startDate: this.startDate,
          endDate: this.endDate
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      return this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        this.isResult = true;
        if (result && result.code === 0) {
          this.physicalArray = result.data;
          this.paginateResult();
        }
        else this.getShowToast(result?.msg || Messages.C001);
      });
    },
    // 分页
    paginateResult() {
      const start = (this.pageCount - 1) * this.perpetual.PAGINATION_SIZE;
      const end = this.pageCount * this.perpetual.PAGINATION_SIZE;
      if (this.isResult) this.physicalInfo = this.physicalArray;
      if (this.physicalArray.slice(start, end).length < this.perpetual.PAGINATION_SIZE) this.isResult = false;
      if (this.physicalArray.slice(start, end).length === 0) this.isResult = false;
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.physicalInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/physical/report/detail' && !this.$sn.validate.empty(item)) {
        this.$sn.utils.setHospitalSessionStorage('PhysicalReport_Info', item);
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.report {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .report-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .sn-table {
        td {
          max-width: 200px;
        }

        .alone-width {
          max-width: 250px;
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
